// @ts-ignore
import Papa from 'papaparse';
import { formatStringToEnum } from './format';
import { format as formatDateToString, parseJSON as parseJSONDate } from 'date-fns';

export const getCSVData = (base64: any) => {
  if (!base64) {
    return;
  }

  try {
    const file = atob(base64.replace('data:text/csv;base64,', ''));

    const { data } = Papa.parse(file.replace('ï»¿', ''), {
      quoteChar: '"',
      escapeChar: '"',
      header: true,
      trimHeaders: true,
      dynamicTyping: true,
      encoding: 'UTF-8',
      skipEmptyLines: true,
    });

    const result = data.map((input: any) => {
      return {
        ...input,
        ...(input.contactPersonContactNumber && {
          contactPersonContactNumber: input.contactPersonContactNumber.toString(),
        }),
        ...(input.leaderContactNumber && { leaderContactNumber: input.leaderContactNumber.toString() }),
        ...(input.role && { role: formatStringToEnum(input.role) }),
        ...(input.status && { status: formatStringToEnum(input.status) }),
      };
    });

    return result;
  } catch (e) {
    return null;
  }
};

export function isObject(item: any) {
  return typeof item === 'object' && !Array.isArray(item) && item !== null;
}

export const cleanCSVData = (data: any, dateFormats?: any): any => {
  /** safety check because typeof null === 'object' */
  if (typeof data === 'undefined' || data === null) {
    return '';
  }

  /** if the child is an array, recursively sanitize the data */
  if (Array.isArray(data)) {
    return data.map(eachValue => {
      return cleanCSVData(eachValue, dateFormats);
    });
  }

  /** if the child is an object,  recursively clean the values of each key*/
  if (isObject(data)) {
    return Object.keys(data).reduce((acc, eachKey) => {
      acc[eachKey] = cleanCSVData(
        data[eachKey],
        dateFormats && dateFormats[eachKey] ? dateFormats[eachKey] : undefined
      );
      return acc;
    }, {});
  }

  if (typeof data === 'boolean') {
    return String(data);
  }

  if (typeof data === 'number') {
    return String(data);
  }

  if (typeof data === 'string') {
    if (dateFormats && data && data.length >= 20) {
      var date = parseJSONDate(data);
      return formatDateToString(date, dateFormats);
    }
    return String(data);
  }

  console.log('needs to be cleaned');
  /**
   * fairly confident this should be typecast as a string by now
   * basically, just wrap each operator symbol in a double quote
   */
  // return (data as string).replace(/[-|+|=]/g, match => `"${match}"`);
  return '';
};

export const sanitizeData = (datas: any, dateFormats?: any) => {
  const result = datas.map((data: any) => {
    return cleanCSVData(data, dateFormats);
  });

  return result;
};

export const parseCSVFile = (file: File, complete: Function, error?: Function) => {
  Papa.parse(file, {
    delimiter: '',
    header: false,
    complete: complete,
    error: error,
    delimitersToGuess: [',', ';'],
  });
};
